import { z } from "zod";

export const loanFormSchema = z.object({
  principal: z.coerce.number().positive("Principal must be greater than 0"),
  annual_interest_rate: z.coerce
    .number()
    .min(0, "Interest rate must be 0 or greater"),
  total_installments: z.coerce
    .number()
    .int("Must be a whole number")
    .positive("Total installments must be greater than 0"),
  disbursement_date: z.string().min(1, "Disbursement date is required").refine(
    (val) => !isNaN(Date.parse(val)),
    "Invalid date"
  ),
  note: z.string().optional(),
});

export type LoanFormValues = z.infer<typeof loanFormSchema>;
